/** Words for a learner-declared assessment's kind and its date (#444). No count, score or percentage. */
import type { AssessmentResponse } from '@davinci/contracts';
import { useLocale, type UiLocale } from '../../i18n/locale.js';

export type AssessmentKind = AssessmentResponse['kind'];

const KINDS: Record<UiLocale, Record<AssessmentKind, string>> = {
  en: { quiz: 'Quiz', midterm: 'Midterm', exam: 'Exam', other: 'Other' },
  he: { quiz: 'בוחן', midterm: 'מבחן אמצע', exam: 'מבחן', other: 'אחר' },
};

export function useAssessmentLabels(): { kind: (kind: AssessmentKind) => string } {
  const { locale } = useLocale();
  return { kind: (kind) => KINDS[locale][kind] };
}

/** A YYYY-MM-DD day shown as a day, in UTC so the zone cannot move it. */
export function assessmentDate(date: string, locale: UiLocale): string {
  const at = new Date(`${date}T00:00:00Z`);
  if (Number.isNaN(at.getTime())) return date;
  return new Intl.DateTimeFormat(locale === 'he' ? 'he-IL' : 'en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(at);
}
